import React, { useEffect, useState } from "react";
import PopupHeader from "../PopupHeader/PopupHeader";
import { TextField, Stack, DefaultButton, PrimaryButton, Dropdown, IDropdownOption, TooltipHost } from "@fluentui/react";
import { localize } from "src/utils/l10n";
import FormControl from "../FormControl/FormControl";
import FormSection from "../FormSection/FormSection";
import { connect } from "react-redux";
import { IApplicationState } from "src/reducer";
import UnstyledButton from "../UnstyledButton/UnstyledButton";
import Label from "../Label/Label";
import Visage2Icon from "../Visage2Icon/Visage2Icon";
import { uniqueId } from "src/utils";
import QuestionAlternativeCollectionForm from "./QuestionAlternativeCollectionForm";

interface IProps {
    question: any;
    onSave: (item: any) => void;
    onCancel: () => void;
    questionAlternativeCollections?: any[];
}

interface IState {
    question: any;
    questionAlternativeCollection?: any;
}

const QuestionForm = (props: IProps) => {
    const [state, setState] = useState<IState>({
        question: props.question,
    });

    if (state.questionAlternativeCollection) {
        return (
            <QuestionAlternativeCollectionForm
                questionAlternativeCollection={state.questionAlternativeCollection}
                onDone={() => {
                    setState((s: IState) => ({
                        ...s,
                        questionAlternativeCollection: undefined
                    }));
                }}
            />
        )
    }

    const renderDropdownItem = (option: IDropdownOption) => {
        const alternatives = option.key === 0 ?
            [
                localize("STRONGLY_AGREE"),
                localize("AGREE"),
                localize("NEITHER_AGREE_DISAGREE"),
                localize("DISAGREE"),
                localize("STRONGLY_DISAGREE"),
            ] :
            props.questionAlternativeCollections.find(x => x.id === option.key).alternatives.map(x => localize(x.text));

        const tooltipText = localize("ANSWER_ALTERNATIVES_DESCRIPTION") + "<br/><br/>" + localize("Alternativ") + ":<br/>" + alternatives.join("<br/>");

        return (
            <div className="answer-alternative-collection-alternative">
                <span>{option.text}</span>
                <TooltipHost
                    className="marketplace-tooltip"
                    content={
                        <span dangerouslySetInnerHTML={{
                            __html: tooltipText
                        }} />
                    }
                >
                    <Visage2Icon icon="info-circle" size="small" color="p-mid-grey-1" />
                </TooltipHost>
            </div>
        );
    }

    return (
        <div className="QuestionForm">
            <PopupHeader
                text={state.question.isNew ?
                    localize("ADD_QUESTION") :
                    localize("EDIT_QUESTION")}
                hideCloseButton />
            <FormSection>
                <FormControl>
                    <TextField
                        value={state.question.text}
                        className="textField"
                        autoAdjustHeight={true}
                        multiline={true}
                        label={localize("QUESTION")}
                        resizable={false}
                        onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, newValue?: string) => {
                            setState((s: IState) => ({
                                ...s,
                                question: {
                                    ...s.question,
                                    text: newValue
                                }
                            }));
                        }}
                        required
                        aria-required
                        validateOnFocusOut
                        validateOnLoad={false}
                        autoFocus
                    />
                </FormControl>
                <FormControl>
                    <Dropdown
                        label={localize("ANSWER_ALTERNATIVE_COLLECTION")}
                        selectedKey={state.question.questionAlternativeCollectionId}
                        required
                        onChange={(_e, v) => {
                            setState(s => ({
                                ...s,
                                question: {
                                    ...s.question,
                                    questionAlternativeCollectionId: Number(v.key)
                                }
                            }));
                        }}
                        options={[
                            {
                                key: 0,
                                text: localize("LIKERT_SCALE")
                            },
                            ...(props.questionAlternativeCollections || []).map(x => ({
                                key: x.id,
                                text: localize(x.text)
                            }))
                        ]}
                        onRenderOption={renderDropdownItem}
                        onRenderTitle={(options: IDropdownOption[]): JSX.Element => {
                            const option = options[0];
                          
                            return renderDropdownItem(option);
                        }}
                        styles={{ dropdown: { width: 250 } }}
                    />
                    {/* <UnstyledButton
                        className="add-button"
                        onClick={() => {
                            setState(s => ({
                                ...s,
                                questionAlternativeCollection: {
                                    id: 0,
                                    isNew: true,
                                    text: "",
                                    alternatives: [
                                        {answer: 5, text: ""},
                                        {answer: 4, text: ""},
                                        {answer: 3, text: ""},
                                        {answer: 2, text: ""},
                                        {answer: 1, text: ""}
                                    ]
                                }
                            }));
                        }}>
                        <Visage2Icon icon="add" color="p-green-1" />
                        <Label
                            size="body-2"
                            weight="medium"
                            color="p-green-1"
                            fontType="display"
                        >
                            {localize("ADD_ANSWER_ALTERNATIVE_COLLECTION")}
                        </Label>
                    </UnstyledButton> */}
                </FormControl>
            </FormSection>
            <Stack className="bottom-buttons" horizontal={true} horizontalAlign="end" tokens={{ childrenGap: 20 }}>
                <DefaultButton
                    onClick={props.onCancel}
                    text={localize("GO_BACK")} />
                <PrimaryButton
                    onClick={() => {
                        props.onSave(state.question);
                    }}
                    text={localize("SAVE")} />
            </Stack>
        </div>
    )
}

const mapStateToProps = (state: IApplicationState, props: IProps) => ({
    ...props,
    questionAlternativeCollections: state.instance.questionAlternativeCollections
});

export default connect(mapStateToProps)(QuestionForm);
